import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * PATCH `/crm/quotations/{id}`：僅 DRAFT。
 * 前端用 `lines[]` 整份替換（保留項目帶回 lineId／subLineId）；不與 line_updates 等局部集合混用。
 */
export async function updateQuotation(id, body) {
  const { data: raw } = await request.patch(`/crm/quotations/${id}`, keysToSnake(body));
  return parseVer4DetailResponse(raw);
}
